<template>
	<div class="form-field col col-12">

		<label>File<input type="file" id="files" ref="files" v-on:change="handleFilesUpload()"/></label>

		<span>{{ file_error }}</span>

		<div class="large-12 medium-12 small-12 cell">
			<button v-on:click="addFiles()">Add Files</button>
		</div>

		<div class="large-12 medium-12 small-12 cell">
			<div v-for="(file, key) in files" class="file-listing">{{ file.name }} <span class="remove-file" v-on:click="removeFile( key )">Remove</span></div>
		</div>

	</div>
</template>

<script>
  export default {

	props: [
		'file_error'
	],

	data(){
      return {
		files: [],
      }
    },
	mounted () {
	},
    methods: {

		handleFilesUpload() {
			let uploadedFiles = this.$refs.files.files
			/*
			Adds the uploaded file to the files array
			*/
			for( var i = 0; i < uploadedFiles.length; i++ ) {
				this.files.push( uploadedFiles[i] )
			}

			this.$emit("files", this.files)
		},
		addFiles(){
			this.$refs.files.click()
		},
		removeFile( key ){
			this.files.splice( key, 1 )
			this.$emit("files", this.files)
		},

	}
  }
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/FileUploadInput.vue